export type ImageGalleryDialogNav = 'GENERATIONS' | 'UPLOADS' | 'AVATARS' | 'FAVORITES';
export const IMAGE_GALLERY_DIALOG_NAV: Record<ImageGalleryDialogNav, ImageGalleryDialogNav> = {
	'GENERATIONS': 'GENERATIONS',
	'UPLOADS': 'UPLOADS',
	'AVATARS': 'AVATARS',
	'FAVORITES': 'FAVORITES',
};
